<template id="bs-modal">
  <div
    class="modal fade"
    id="firstStart"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <!--div class="modal-body text-center"-->
        <div class="card text-center">
          <img src="img/welcome.jpg" class="card-img-top" alt="img/welcome.jpg" />
          <div v-show="!cookiesAccepted" class="card-body">
            <h5 class="card-title">Hallo!</h5>
            <p class="card-text">
              Erstmal wird es förmlich. Diese Website nutzt Cookies um Ihre Einstellungen zu speichern (First-Party-Cookies): Durch die Nutzung unserer Webseite stimmen Sie der Cookie-Nutzung zu.
              <router-link to="/dsvgo" data-dismiss="modal" class="nav-link">Datenschutzerklärung</router-link>
            </p>
            <button
              type="button"
              class="btn btn-sm btn-primary mr-2"
              @click="doCookiesAccepted"
            >OK</button>
          </div>

          <div v-show="cookiesAccepted" class="card-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h5 class="card-title">Los geht's!</h5>
            <p
              class="card-text"
            >Indie42.de ist Dein Rss-Reader. Noch nicht ganz perfekt, daher verzeit kleinere Fehler.</p>
            <p
              class="card-text"
            >Zum Start habe ich Dir ein paar interessante Feeds zusammengestellt.</p>
            <p class="card-text">
              Eigene Feeds kannst Du mit dem Astronauten
              <router-link to="/user" data-dismiss="modal">
                <i class="fas fa-user-astronaut" />
              </router-link>verwalten.
            </p>

            <button type="button" class="btn btn-primary" data-dismiss="modal">Schliessen</button>
          </div>
        </div>
        <!--/div-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FirstStart",
  data: function() {
    return {
      cookiesAccepted: false,
    };
  },methods: {
    doSend: function() {
      var event = new CustomEvent("vue2html", {
        detail: {
          id: "#firstStart",
          config: { keyboard: false, backdrop: "static", show: true }
        }
      });
      document.dispatchEvent(event);
    },
    doCookiesAccepted: function() {
      window.localStorage.setItem("CookiesAccept", true);
      this.cookiesAccepted = true;

      window.localStorage.setItem("FirstStart", true);

    }
  },
  mounted() {
    this.doSend();
  }
};
</script>

<style scoped>
a.test {
  color: #ffffff;
}
